import React from 'react'
import { Row } from 'antd'
import { useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import {
  developersMainChartDataSelector,
  userIsApiPremiumSelector
} from 'src/features'
import {
  CustomCol,
  CustomCard,
  DevelopersCardAPI,
  DevelopersUsageChart,
  DevelopersMyIntegrationList,
  MassCalculationCard
} from 'src/components'

const DevelopersPageContent: React.FC = () => {
  const { t } = useTranslation()
  const { loading } = useAppSelector(developersMainChartDataSelector)
  const isCalculationVisible = useAppSelector(userIsApiPremiumSelector)

  return <>
    <Row className='account-content-margin'>
      <CustomCol>
        <CustomCard cardTitle={t('developers.ClimateTradeForDevelopers')}>
          <DevelopersCardAPI />
        </CustomCard>
      </CustomCol>
      <CustomCol>
        <DevelopersUsageChart loading={loading}/>
      </CustomCol>
    </Row>
    <DevelopersMyIntegrationList />
    {isCalculationVisible && <div className='mt-4'>
      <MassCalculationCard />
    </div>}
  </>
}

export default DevelopersPageContent
